import disciplines from 'leverade-disciplines-i18n/i18n/en'
import { activities } from '@/src/server/i18n/en/activities'

export default {
  activities,
  disciplines,

  empty: 'No data to display',
  event_list: 'Event list',
  filter_select_default: 'Clean filter',
  filter_select_default_active: 'Filter by...',
  photo: '{count} photo | {count} photos',
  postponed: 'Postponed',
  rest: 'Rest',
  view_calendar: 'View calendar',
}



// WEBPACK FOOTER //
// ./src/server/i18n/en/index.js